export default __webpack_public_path__ + "static/media/Cuprum-Italic.ae2240ac.ttf";